var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g, _path95, _path96, _g2, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinoparksHomeMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 275,
    viewBox: "0 0 390 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6036_31799)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2132 349.99L21.2132 349.973L19.2782 349.973C5.95218 349.973 -4.84599 344.081 -4.84599 336.81L-4.846 26.9905C1.55176 26.8713 7.96512 27.0756 14.3473 27.6887C34.6328 29.6384 52.4061 35.2835 66.3408 43.4572C89.8252 57.2334 104.306 76.7483 136.373 85.6543C148.17 88.9323 161.184 90.1158 173.761 87.4167C185.651 84.8624 195.154 80.0007 205.094 75.7776C217.64 70.4562 230.794 66.3352 247.007 65.7988C263.189 65.2624 279.09 67.5187 294.444 70.0475C325.98 75.2412 358.094 82.1719 391.55 78.366C392.72 78.2298 393.875 78.068 395.029 77.9147C412.054 71.6737 427.658 64.3258 440.578 55.5901C482.398 27.3225 491.043 -9.20398 499.36 -44.0446C507.802 -79.4643 517.757 -116.919 566.365 -143.254C567.051 -143.62 567.504 -144.02 567.8 -144.42C569.61 -145.28 571.436 -146.14 573.262 -147L573.262 336.81C573.262 344.081 562.463 349.973 549.137 349.973L100.592 349.973C74.1273 349.973 47.6624 349.973 21.1976 349.99L21.2132 349.99Z",
    fill: "url(#paint0_radial_6036_31799)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.26428 183.576C9.33749 178.437 24.4378 176.849 37.4712 177.748C54.1172 178.905 67.3442 183.259 74.6067 190.905C82.8972 199.622 84.9761 211.206 91.9773 220.528C101.739 233.515 121.871 239.193 150.219 238.849C177.736 238.51 208.584 233.948 235.965 233.792C251.633 233.701 266.419 234.771 281.133 235.666C297.661 236.666 313.847 238.037 329.059 240.26C357.931 244.469 384.944 251.449 400.603 264.824C405.464 268.988 409.27 273.723 412.161 278.9L159.694 383.634C134.072 394.263 108.451 404.892 82.8348 415.534L82.8293 415.521L80.956 416.298C68.0546 421.65 55.6724 421.339 53.2928 415.602L-37.7617 196.11C-27.9684 191.205 -17.7486 186.816 -7.27939 183.583L-7.26428 183.576Z",
    fill: "url(#paint1_radial_6036_31799)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9966 235.013C69.9966 235.013 37.4917 221.551 33.847 207.041C30.2023 192.541 59.7532 197.441 82.3334 226.98C82.3334 226.98 48.9784 171.268 69.7309 167.235C90.4941 163.192 101.747 221.646 101.747 221.646C101.747 221.646 107.613 192.901 121.182 194.308C134.751 195.716 126.878 217.857 104.478 235.003H69.9966V235.013Z",
    fill: "url(#paint2_radial_6036_31799)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0126 232.738C93.0126 232.738 89.1235 200.235 68.9022 168.971",
    stroke: "url(#paint3_radial_6036_31799)",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3332 231.891C82.3332 231.891 52.7611 217.614 39.4362 200.235",
    stroke: "url(#paint4_radial_6036_31799)",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.182 198.14C121.182 198.14 111.13 227.33 96.5085 231.881",
    stroke: "url(#paint5_radial_6036_31799)",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.237 237.384C235.237 237.384 195.119 230.492 174.477 220.071C162.534 214.045 158.909 203.514 176.061 204.104C184.708 204.402 203.491 193.475 172.199 180.5C144.907 169.18 146.599 145.289 171.445 152.195C177.281 153.82 170.064 147.455 165.921 130.644C162.741 117.713 167.343 99.7637 177.679 96.9723C199.466 91.0972 190.599 132.467 198.204 136.471C205.508 140.322 213.172 117.715 223.278 123.353C236.484 130.726 204.902 169.232 206.884 173.913C211.116 183.891 230.615 144.932 240.342 150.988C250.071 157.034 203.493 218.319 235.219 237.38L235.237 237.384Z",
    fill: "url(#paint6_radial_6036_31799)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.771 232.921C206.28 217.727 212.817 200.577 192.688 170.561C176.048 145.743 175.065 122.226 181.817 97.331",
    stroke: "url(#paint7_radial_6036_31799)",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.366 216.072C303.366 216.072 331.783 191.984 334.97 166.021C338.156 140.077 313.808 142.955 294.067 195.809C294.067 195.809 323.571 106.179 305.419 98.9449C287.266 91.7109 275.598 192.155 275.598 192.155C275.598 192.155 270.471 140.721 258.607 143.239C246.744 145.758 253.628 185.375 273.211 216.053H303.356L303.366 216.072Z",
    fill: "url(#paint8_radial_6036_31799)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283.117 211.793C283.117 211.793 287.967 149.11 306.072 102.074",
    stroke: "url(#paint9_radial_6036_31799)",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.455 210.236C292.455 210.236 315.948 167.2 330.195 159.268",
    stroke: "url(#paint10_radial_6036_31799)",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M258.605 149.93C258.605 149.93 267.324 202.102 280.005 210.236",
    stroke: "url(#paint11_radial_6036_31799)",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.898 210.944C136.506 210.944 66.4717 221.151 66.4717 233.743C66.4717 246.334 136.506 256.542 222.898 256.542C309.289 256.542 379.324 246.334 379.324 233.743C379.324 221.151 309.289 210.944 222.898 210.944Z",
    fill: "url(#paint12_radial_6036_31799)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.516 119.264C92.7895 98.8413 105.895 63.2368 120.961 39.3889C120.266 38.8413 119.574 38.2871 118.859 37.7656C118.233 37.3092 117.622 36.8333 117.014 36.3552C115.592 35.236 114.187 34.0951 112.734 33.0173C112.501 32.8434 112.265 32.6739 112.029 32.5044C106.424 40.1147 92.3662 61.6113 87.4693 91.5266C81.298 129.241 101.294 160.386 113.885 166.956L130.179 141.893C130.179 141.893 114.379 139.946 103.516 119.264Z",
    fill: "url(#paint13_linear_6036_31799)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.516 119.264C92.7895 98.8413 105.895 63.2368 120.961 39.3889C120.266 38.8412 119.574 38.2871 118.859 37.7655C118.233 37.3114 117.622 36.8333 117.014 36.3552C115.592 35.236 114.187 34.0951 112.734 33.0173C112.501 32.8434 112.265 32.6739 112.029 32.5044C110.935 33.9886 109.52 36.0031 107.917 38.5022C108.12 39.2976 108.428 40.0625 108.854 40.7558C109.443 41.7163 110.291 42.3595 111.175 43.0375C111.87 43.57 112.523 44.1502 112.853 44.9738C113.599 46.8318 112.598 49.0549 111.819 50.7478C110.843 52.8753 109.608 54.8702 108.503 56.9347C107.119 59.5273 106.058 62.3284 105.026 65.0709C103.946 67.9394 102.989 70.8536 102.16 73.8025C100.645 79.1875 99.2253 84.6269 98.1758 90.1206C96.0746 101.125 95.4771 113.114 101.088 123.256C102.511 125.829 104.272 128.213 106.239 130.408C107.154 131.43 108.113 132.425 109.125 133.357C109.932 134.1 110.845 134.72 111.729 135.365C113.241 136.469 115.052 137.751 115.631 139.611C116.277 141.687 115.526 143.801 114.626 145.683C114.108 146.77 113.508 147.815 112.922 148.867C112.298 149.986 111.771 151.146 111.231 152.307C110.033 154.875 108.704 157.657 108.481 160.519C108.419 161.323 108.4 162.142 108.426 162.957C110.324 164.711 112.172 166.061 113.883 166.954L130.177 141.891C130.177 141.891 114.377 139.944 103.514 119.262L103.516 119.264Z",
    fill: "#D8C6FF"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.769 34.8144C129.431 34.3168 129.121 33.7952 128.931 33.2237C128.721 32.5869 128.71 31.9546 128.737 31.2939C128.763 30.6398 128.763 29.9879 128.655 29.3403C128.543 28.6666 128.265 28.056 127.853 27.5083C127.844 27.4953 127.833 27.4888 127.82 27.4823C127.906 26.6565 127.879 25.8176 127.619 25.0245C126.711 22.2733 123.337 21.1519 120.727 22.1646C120.054 22.4254 119.422 22.8166 118.857 23.2642C118.593 23.3837 118.31 23.475 118.05 23.5663C117.6 23.7228 117.131 23.8292 116.668 23.9357C115.746 24.1465 114.798 24.3703 113.951 24.7963C113.08 25.2352 112.21 25.8155 111.548 26.5326C110.84 27.2997 110.481 28.2233 110.393 29.2512C110.349 29.7641 110.358 30.2813 110.324 30.7941C109.623 31.2765 108.984 31.8459 108.501 32.55C107.877 33.4605 107.692 34.4754 107.84 35.5533C108.009 36.8072 108.459 38.048 108.986 39.1976C109.405 40.1147 109.945 40.9687 110.662 41.6902C111.414 42.4443 112.296 43.1005 113.303 43.4787C114.399 43.8894 115.581 43.998 116.685 44.3805C119.049 45.1998 120.804 47.1665 123.168 47.9814C124.31 48.3747 125.569 48.3747 126.559 47.6293C126.96 47.3273 127.295 46.9448 127.685 46.6275C127.798 46.5363 127.919 46.4341 128.049 46.3385C128.314 46.4037 128.591 46.4146 128.893 46.3407C130.022 46.0625 130.794 45.1694 131.447 44.2762C132.137 43.3331 132.695 42.1987 132.75 41.0209C132.86 38.6087 131.039 36.6855 129.767 34.8144H129.769Z",
    fill: "url(#paint14_linear_6036_31799)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.64
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.942 42.6986C130.75 43.0224 130.576 43.3549 130.441 43.7047C130.316 44.0307 130.199 44.398 130.214 44.7544C130.371 44.6957 130.512 44.6022 130.635 44.4892C131.112 44.0546 131.489 43.1289 130.94 42.6986H130.942Z",
    fill: "#6960A1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.64
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.923 43.6417C127.886 44.1719 128.166 44.6761 128.552 45.0325C128.602 44.5762 128.624 44.1155 128.691 43.6613C128.744 43.2962 128.821 42.9137 128.993 42.579C128.453 42.7116 127.965 43.0441 127.923 43.6417Z",
    fill: "#6960A1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.978 144.653C107.022 144.466 107.033 144.271 106.973 144.084C106.923 143.927 106.865 143.797 106.731 143.688C106.647 143.621 106.548 143.575 106.444 143.545C106.321 143.486 106.188 143.447 106.047 143.445C105.791 143.441 105.551 143.534 105.359 143.697C105.024 143.982 104.874 144.408 104.872 144.836C104.872 145.203 105.053 145.598 105.432 145.714C106.063 145.905 106.713 145.44 106.92 144.86C106.931 144.827 106.94 144.792 106.951 144.76C106.967 144.725 106.975 144.69 106.98 144.655L106.978 144.653Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.393 145.275C108.159 145.253 107.89 145.39 107.796 145.607C107.707 145.807 107.813 146.013 108.04 146.035C108.274 146.057 108.543 145.92 108.638 145.703C108.726 145.503 108.62 145.296 108.393 145.275Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.282 138.962C109.233 138.809 109.178 138.655 109.096 138.516C109.09 138.492 109.079 138.468 109.057 138.449C109.054 138.449 109.052 138.444 109.05 138.442C109.043 138.434 109.039 138.423 109.032 138.414C108.975 138.336 108.911 138.251 108.827 138.192C108.68 138.09 108.51 138.038 108.327 138.06C108.082 138.092 107.862 138.214 107.701 138.399C107.361 138.646 107.13 139.031 107.165 139.459C107.198 139.87 107.546 140.183 107.904 140.35C108.21 140.494 108.569 140.491 108.865 140.32C109.136 140.163 109.328 139.883 109.35 139.57C109.365 139.361 109.345 139.159 109.282 138.959V138.962Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.619 134.444C102.416 134.424 102.182 134.544 102.098 134.733C102.021 134.907 102.114 135.087 102.312 135.106C102.515 135.126 102.749 135.007 102.833 134.817C102.91 134.644 102.817 134.463 102.619 134.444Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7671 120.829C96.7428 120.801 96.7208 120.775 96.6965 120.746C96.6524 120.707 96.5995 120.686 96.5422 120.677C96.5025 120.662 96.4628 120.657 96.4209 120.664C96.3526 120.66 96.2864 120.668 96.2225 120.692C96.1189 120.72 96.0329 120.783 95.9469 120.846L95.9359 120.855C95.916 120.87 95.8962 120.89 95.8807 120.912C95.8609 120.929 95.8433 120.949 95.8278 120.968C95.7727 121.035 95.7374 121.112 95.722 121.196C95.722 121.207 95.722 121.218 95.722 121.231C95.7066 121.303 95.7044 121.377 95.7066 121.448C95.7066 121.501 95.7176 121.551 95.733 121.601C95.7374 121.65 95.7595 121.692 95.7948 121.727C95.8212 121.768 95.8609 121.796 95.9094 121.811C95.9425 121.82 95.9778 121.829 96.0108 121.835C96.0704 121.844 96.1255 121.84 96.1828 121.822C96.2247 121.818 96.2644 121.805 96.3019 121.783C96.3636 121.761 96.4187 121.729 96.4672 121.683C96.551 121.607 96.6172 121.516 96.6392 121.403C96.6392 121.396 96.6436 121.39 96.6436 121.383C96.6502 121.366 96.659 121.348 96.6657 121.333C96.6745 121.325 96.6833 121.318 96.6899 121.307C96.7406 121.24 96.7869 121.153 96.798 121.07C96.798 121.064 96.798 121.057 96.8002 121.051C96.8134 120.955 96.8024 120.916 96.7649 120.829H96.7671Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6017 115.524C96.5907 115.453 96.5554 115.394 96.5003 115.346C96.4959 115.342 96.4915 115.338 96.4849 115.331C96.4716 115.318 96.4606 115.314 96.4474 115.305C96.4386 115.281 96.4297 115.255 96.4209 115.231C96.3989 115.188 96.3636 115.157 96.3217 115.138C96.2953 115.118 96.2666 115.105 96.2313 115.103C96.1806 115.085 96.1277 115.083 96.0726 115.092C96.0351 115.101 95.9954 115.109 95.9579 115.116C95.8785 115.142 95.8058 115.183 95.7396 115.238C95.7198 115.253 95.7 115.27 95.6801 115.288L95.6757 115.294C95.6448 115.314 95.6162 115.331 95.5875 115.355C95.4905 115.438 95.4067 115.553 95.3869 115.679C95.3803 115.718 95.3825 115.759 95.3869 115.798C95.3913 115.84 95.4111 115.881 95.4266 115.918C95.4266 115.92 95.4288 115.924 95.431 115.926C95.453 115.959 95.4817 115.99 95.5081 116.02C95.5125 116.026 95.5192 116.031 95.5258 116.035C95.5633 116.061 95.6051 116.085 95.647 116.105C95.7286 116.142 95.83 116.144 95.916 116.137C95.9226 116.137 95.9293 116.137 95.9359 116.135C95.9491 116.135 95.9645 116.131 95.9778 116.126C96.0064 116.12 96.077 116.107 96.1233 116.094C96.1475 116.085 96.1718 116.074 96.1938 116.063C96.2181 116.055 96.2423 116.046 96.2644 116.033C96.271 116.029 96.2776 116.024 96.2842 116.02C96.3658 115.974 96.4364 115.916 96.4937 115.844C96.5334 115.796 96.562 115.744 96.5753 115.685C96.5973 115.635 96.6039 115.581 96.5929 115.524H96.6017Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2604 97.933C92.234 97.8135 92.1965 97.6765 92.1149 97.5809C92.0488 97.5027 91.9848 97.4484 91.8746 97.4397C91.7511 97.4288 91.6431 97.4614 91.5328 97.5157C91.4226 97.5701 91.3256 97.6439 91.2418 97.7309C90.6862 97.9243 90.4833 98.7023 90.8758 99.1369C91.1095 99.3955 91.5395 99.3955 91.8217 99.2238C92.1149 99.0456 92.2693 98.724 92.2891 98.3937C92.2979 98.2416 92.2957 98.0873 92.2604 97.9373V97.933Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.797 106.545C95.4487 106.51 95.0628 107.091 95.5236 107.134C95.872 107.169 96.2578 106.589 95.797 106.545Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5101 103.448C97.4946 103.344 97.4285 103.255 97.3425 103.198C97.2631 103.144 97.1727 103.118 97.0757 103.125C97.0206 103.003 96.8663 102.99 96.7494 103.025C96.3966 103.131 96.0968 103.388 96.0064 103.746C95.9314 104.039 96.0791 104.361 96.304 104.55C96.4253 104.652 96.6061 104.646 96.7494 104.602C96.8376 104.574 96.9192 104.528 96.9897 104.47C97.0537 104.415 97.1044 104.35 97.1419 104.276C97.2278 104.131 97.316 103.985 97.3932 103.837C97.4572 103.716 97.5321 103.596 97.5101 103.451V103.448Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.356 95.5186C94.9966 95.4838 94.5975 96.0814 95.0737 96.1271C95.4331 96.1618 95.8322 95.5642 95.356 95.5186Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7291 91.3919C96.4671 91.3658 96.1764 91.8021 96.5243 91.8346C96.7864 91.8607 97.0771 91.4244 96.7291 91.3919Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.314 67.3309C102.314 67.2983 102.31 67.2679 102.303 67.2353C102.308 67.2223 102.314 67.2092 102.317 67.1962C102.317 67.1897 102.317 67.0832 102.317 67.0767C102.308 66.9897 102.286 66.9745 102.239 66.9224C102.213 66.8854 102.178 66.8572 102.138 66.8376C102.118 66.8159 102.101 66.792 102.081 66.7703C102.03 66.729 101.975 66.7029 101.911 66.6942C101.796 66.666 101.668 66.6703 101.556 66.7116C101.455 66.7485 101.357 66.8007 101.274 66.8681C101.159 66.9593 101.093 67.0832 101.055 67.2201C101.044 67.2636 101.04 67.307 101.038 67.3505C100.952 67.4722 100.894 67.6047 100.892 67.7612C100.892 67.8742 100.914 67.9611 100.956 68.0654C100.996 68.1676 101.077 68.2545 101.148 68.3349C101.21 68.4066 101.375 68.424 101.461 68.411C101.591 68.3936 101.723 68.3436 101.821 68.2545C101.922 68.1589 102.023 68.0589 102.103 67.9459C102.198 67.8134 102.257 67.6917 102.299 67.5352C102.317 67.4678 102.314 67.4005 102.314 67.3331V67.3309Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6729 79.4701C99.3114 79.4353 98.9079 80.0373 99.3885 80.0851C99.7501 80.1198 100.154 79.5179 99.6729 79.4701Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9361 75.5606C98.6564 75.5346 98.3459 75.999 98.7159 76.0338C98.9955 76.0598 99.3061 75.5953 98.9361 75.5606Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7184 77.6359L98.725 77.625C98.736 77.6055 98.747 77.5881 98.7581 77.5664C98.8132 77.4512 98.8374 77.3251 98.7691 77.2078C98.7448 77.1643 98.7095 77.1274 98.6743 77.0926C98.6236 77.0535 98.5662 77.0296 98.5001 77.0231C98.445 77.0166 98.3921 77.0187 98.3391 77.0361C98.2796 77.0448 98.2245 77.0644 98.1738 77.097C98.1341 77.1187 98.101 77.1448 98.0679 77.173L98.0724 77.1687C98.0724 77.1687 98.0657 77.173 98.0635 77.1752H98.0591C98.0591 77.1752 98.0393 77.1774 98.0283 77.1795C98.015 77.173 98.0018 77.1665 97.9886 77.16C97.9996 77.1665 98.0128 77.173 98.0238 77.1795C97.8739 77.0731 97.6468 77.1491 97.5278 77.2665C97.4881 77.2991 97.4572 77.3404 97.4352 77.386C97.4153 77.4273 97.4087 77.4686 97.4131 77.5142C97.444 77.6055 97.4726 77.6967 97.5057 77.7858C97.5234 77.8315 97.541 77.8749 97.5674 77.9141C97.6027 77.964 97.6446 78.014 97.6953 78.051C97.7527 78.0923 97.8166 78.1205 97.8783 78.1509C97.896 78.1618 97.9136 78.1727 97.9312 78.1835C97.9687 78.2161 98.0106 78.2357 98.0591 78.2422C98.1098 78.2596 98.1605 78.2618 98.2135 78.2531C98.3149 78.24 98.4053 78.2031 98.4891 78.1444C98.564 78.0923 98.639 78.0227 98.6743 77.938C98.6831 77.9075 98.6941 77.8749 98.7029 77.8445C98.7095 77.8054 98.7051 77.7685 98.6963 77.7315C98.6919 77.7163 98.6875 77.7011 98.6831 77.6881C98.6919 77.6728 98.7029 77.6555 98.714 77.6337L98.7184 77.6359Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M98.295 73.3679C97.94 73.3332 97.5453 73.9243 98.0172 73.9699C98.3721 74.0047 98.7668 73.4136 98.295 73.3679Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.641 63.4128C107.657 63.3845 107.668 63.3541 107.677 63.3237C107.685 63.3128 107.699 63.3063 107.705 63.2954C107.71 63.2911 107.76 63.1955 107.763 63.189C107.793 63.1085 107.782 63.0846 107.767 63.0173C107.763 62.9716 107.743 62.9325 107.714 62.8956L107.694 62.8087C107.67 62.7478 107.63 62.7 107.58 62.6652C107.489 62.5892 107.375 62.537 107.255 62.5218C107.147 62.5088 107.037 62.5131 106.931 62.5348C106.788 62.5653 106.671 62.6457 106.576 62.75C106.546 62.7847 106.521 62.8195 106.499 62.8586C106.367 62.9282 106.254 63.0216 106.18 63.1607C106.127 63.2607 106.107 63.3476 106.096 63.4606C106.085 63.5693 106.118 63.6823 106.142 63.7866C106.164 63.8778 106.305 63.9669 106.385 63.9952C106.508 64.0365 106.651 64.0517 106.777 64.0169C106.912 63.9778 107.048 63.9343 107.172 63.8691C107.317 63.7931 107.427 63.7127 107.535 63.591C107.582 63.5388 107.61 63.478 107.641 63.4171V63.4128Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M109.158 52.6384C108.852 52.445 108.215 52.8014 108.622 53.0578C108.929 53.2512 109.566 52.8948 109.158 52.6384Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M110.306 48.8267C110.071 48.677 109.58 48.9526 109.892 49.1501C110.128 49.2999 110.619 49.0243 110.306 48.8267Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M109.154 50.5783C109.154 50.5783 109.16 50.574 109.165 50.5718C109.182 50.5588 109.202 50.5479 109.22 50.5349C109.321 50.4588 109.403 50.3545 109.396 50.2197C109.396 50.1698 109.381 50.122 109.365 50.0741C109.339 50.0155 109.297 49.9698 109.242 49.9351C109.196 49.9046 109.147 49.8829 109.094 49.8742C109.037 49.8547 108.98 49.8481 108.918 49.8525C108.874 49.8525 108.83 49.8612 108.788 49.8721H108.792C108.792 49.8721 108.786 49.8721 108.781 49.8721H108.777C108.777 49.8721 108.759 49.8634 108.748 49.8612C108.739 49.8503 108.73 49.8373 108.722 49.8264C108.728 49.8373 108.737 49.8481 108.744 49.859C108.66 49.6982 108.422 49.6634 108.261 49.7134C108.21 49.7243 108.164 49.746 108.122 49.7786C108.087 49.8069 108.06 49.8416 108.045 49.8829C108.029 49.9764 108.014 50.072 108.003 50.1676C107.996 50.2154 107.992 50.2632 107.998 50.311C108.005 50.3719 108.021 50.4349 108.049 50.4892C108.082 50.5501 108.124 50.6044 108.164 50.6609C108.175 50.6783 108.186 50.6957 108.197 50.7152C108.215 50.7609 108.245 50.7978 108.285 50.8239C108.323 50.8608 108.367 50.8869 108.417 50.9043C108.514 50.9369 108.611 50.9456 108.713 50.9325C108.803 50.9195 108.902 50.8912 108.973 50.8304C108.995 50.8065 109.019 50.7848 109.041 50.7609C109.066 50.7283 109.079 50.6935 109.088 50.6565C109.09 50.6413 109.094 50.6261 109.096 50.6109C109.112 50.6 109.13 50.5914 109.149 50.5783H109.154Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M110.748 46.5863C110.448 46.3972 109.824 46.745 110.221 46.997C110.521 47.1861 111.145 46.8384 110.748 46.5863Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1482 132.851C99.1063 132.725 99.0622 132.61 98.9784 132.505C98.8638 132.364 98.7535 132.273 98.5926 132.184C98.3699 132.062 98.0921 132.016 97.8408 132.049C97.7834 132.055 97.7261 132.068 97.6688 132.084C97.6004 132.058 97.5277 132.038 97.4505 132.034C97.133 132.012 96.8331 132.19 96.6568 132.444C96.3349 132.914 96.2952 133.568 96.5487 134.076C96.6722 134.326 96.9037 134.541 97.1771 134.618C97.6776 134.757 98.231 134.611 98.6301 134.296C98.8439 134.126 99.0225 133.881 99.1063 133.622C99.1857 133.375 99.2298 133.101 99.146 132.849L99.1482 132.851Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9675 133.797L97.974 133.787L97.9643 133.797H97.9675Z",
    fill: "#3421AB"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.36 150.203C106.367 150.166 106.36 150.132 106.343 150.099C105.994 149.653 106.144 149.758 105.981 149.782C105.939 149.79 105.897 149.799 105.858 149.808C105.811 149.823 105.767 149.842 105.725 149.866C105.65 149.91 105.578 149.969 105.525 150.036C105.498 150.068 105.474 150.105 105.459 150.145C105.432 150.192 105.421 150.242 105.425 150.295C105.419 150.344 105.43 150.392 105.456 150.436C105.481 150.481 105.516 150.514 105.562 150.536C105.606 150.566 105.655 150.584 105.71 150.586C105.75 150.586 105.787 150.586 105.827 150.586C105.913 150.575 105.994 150.549 106.072 150.505C106.1 150.486 106.127 150.466 106.155 150.447H106.157V150.442C106.157 150.442 106.173 150.434 106.18 150.429C106.186 150.425 106.191 150.418 106.195 150.412C106.215 150.397 106.237 150.381 106.255 150.362C106.268 150.351 106.277 150.34 106.285 150.327C106.292 150.318 106.303 150.314 106.31 150.308C106.336 150.275 106.352 150.24 106.36 150.199V150.203Z",
    fill: "#3421AB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M108.739 157.485C108.757 157.468 108.77 157.455 108.785 157.44C108.794 157.431 108.803 157.42 108.811 157.409C108.787 157.435 108.763 157.459 108.739 157.485Z",
    fill: "#3421AB"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M109.496 151.533C109.482 151.516 109.467 151.501 109.454 151.483C109.445 151.451 109.432 151.422 109.405 151.398C109.381 151.362 109.346 151.335 109.302 151.322C109.297 151.322 109.291 151.318 109.286 151.318C109.28 151.316 109.209 151.299 109.2 151.296C109.152 151.29 109.103 151.294 109.057 151.307C109.004 151.316 108.955 151.333 108.909 151.362H108.905C108.905 151.362 108.9 151.366 108.898 151.368C108.867 151.388 108.832 151.414 108.803 151.433V151.438C108.777 151.464 108.75 151.49 108.726 151.516C108.693 151.555 108.671 151.598 108.66 151.646C108.651 151.661 108.647 151.677 108.647 151.692C108.647 151.72 108.647 151.75 108.647 151.779C108.651 151.811 108.658 151.837 108.675 151.861C108.693 151.883 108.713 151.907 108.733 151.929C108.737 151.933 108.742 151.937 108.746 151.942L108.753 151.95H108.755C108.755 151.95 108.761 151.959 108.766 151.961C108.792 151.979 108.819 151.996 108.847 152.009C108.852 152.009 108.856 152.013 108.861 152.013C108.894 152.022 108.925 152.033 108.96 152.037C108.964 152.037 108.971 152.037 108.977 152.037C109.019 152.037 109.066 152.042 109.108 152.033C109.158 152.029 109.207 152.016 109.251 151.992C109.299 151.974 109.346 151.948 109.385 151.911L109.454 151.842C109.482 151.807 109.502 151.768 109.513 151.727C109.524 151.703 109.529 151.677 109.526 151.648C109.531 151.609 109.522 151.572 109.502 151.538L109.496 151.533Z",
    fill: "#3421AB"
  })))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M248.157 210.112C243.648 198.599 233.197 189.8 222.118 183.898C214.833 180.016 206.964 177.702 199.475 174.312C194.064 171.863 189.778 168.842 185.525 164.859C185.071 164.435 184.949 164.105 184.363 163.861C184.025 163.72 182.901 163.829 182.733 163.681C182.195 163.205 181.668 162.716 181.148 162.219C181.051 162.125 180.8 162.327 180.899 162.429C181.347 162.881 181.805 163.325 182.268 163.761C181.766 163.87 181.269 164.048 180.802 164.263C179.384 164.913 177.986 165.659 176.67 166.489C171.542 169.722 167.417 174.601 165.207 180.199C163.399 184.782 162.603 190.437 164.896 195C166.678 198.547 170.19 200.739 173.841 202.093C177.927 203.608 182.306 204.243 186.618 204.771C188.645 205.018 190.675 205.231 192.701 205.49C195.594 205.861 198.48 206.324 201.355 206.813C207.988 207.943 214.664 209.425 220.793 212.244C223.759 213.609 226.601 215.295 229.116 217.364C231.55 219.367 233.735 221.827 234.93 224.757C235.576 226.339 235.881 227.977 235.673 229.681C234.214 241.681 220.753 251.471 209.108 252.414C207.562 252.54 207.088 252.855 208.554 253.562C211.204 254.837 217.739 253.416 220.456 252.851C228.334 251.215 233.065 249.454 239.521 244.521C250.21 236.351 252.913 222.249 248.162 210.114L248.157 210.112Z",
    fill: "url(#paint15_linear_6036_31799)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M229.112 217.362C231.546 219.365 233.731 221.825 234.926 224.755C235.572 226.337 235.876 227.975 235.669 229.679C235.484 231.194 235.109 232.674 234.571 234.104C235.539 232.1 236.218 229.964 236.471 227.756C236.906 223.962 235.881 220.135 234.229 216.723C232.49 213.128 229.989 209.904 227.039 207.192C220.608 201.278 212.11 198.153 203.875 195.541C199.598 194.185 195.31 192.879 191.083 191.369C187.313 190.022 183.567 188.377 180.39 185.927C178.829 184.724 177.444 183.324 176.405 181.653C175.442 180.103 174.78 178.385 174.362 176.618C173.742 174.001 173.625 171.307 173.711 168.623C169.963 171.707 166.969 175.718 165.203 180.195C163.395 184.778 162.599 190.432 164.892 194.996C166.673 198.542 170.186 200.735 173.837 202.089C177.922 203.604 182.301 204.238 186.614 204.766C188.64 205.014 190.671 205.227 192.697 205.486C195.59 205.857 198.476 206.32 201.351 206.809C207.983 207.939 214.659 209.421 220.789 212.24C223.754 213.604 226.596 215.291 229.112 217.36V217.362Z",
    fill: "url(#paint16_linear_6036_31799)"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M188.281 177.589C187.8 172.119 184.407 167.106 178.868 165.55C171.057 163.355 164.136 168.773 162.52 176.129C160.835 183.789 161.847 191.866 163.291 199.496C164.164 204.108 165.368 208.658 166.892 213.102C168.193 216.901 171.65 221.88 170.944 225.978C170.834 226.617 170.389 227.191 170.395 227.853C170.404 228.89 171.626 229.12 172.455 229.186C173.846 229.294 175.237 229.407 176.631 229.501C178.108 229.601 179.598 229.644 181.073 229.477C182.293 229.338 183.653 229.075 184.683 228.373C185.664 227.704 186.028 226.602 185.776 225.467C185.613 224.735 185.245 224.072 184.965 223.379C184.945 223.329 184.93 223.279 184.91 223.231C184.83 222.734 184.729 222.238 184.643 221.743C183.161 213.113 181.519 205.131 184.18 196.526C186.047 190.487 188.85 184.017 188.285 177.585L188.281 177.589Z",
    fill: "#FA9621"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M174.218 229.485C174.218 229.485 174.227 229.481 174.234 229.477C174.295 229.44 174.357 229.399 174.419 229.357C174.481 229.068 174.538 228.779 174.569 228.486C174.617 228.027 174.653 227.471 174.379 227.067C174.165 226.75 173.804 226.637 173.477 226.854C173.133 227.082 172.906 227.482 172.721 227.838C172.662 227.953 172.611 228.071 172.558 228.19C172.417 228.653 172.353 229.164 172.587 229.349C172.662 229.407 172.761 229.427 172.856 229.442C173.182 229.492 173.779 229.588 174.216 229.483L174.218 229.485Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M174.536 227.419C174.544 227.519 174.551 227.617 174.551 227.717C174.551 228.095 174.474 228.501 174.238 228.807C173.969 229.155 173.568 229.236 173.144 229.242C172.902 229.244 172.646 229.209 172.45 229.079C172.47 229.196 172.514 229.292 172.589 229.353C172.664 229.412 172.763 229.431 172.858 229.446C173.184 229.496 173.782 229.592 174.218 229.488C174.223 229.485 174.227 229.483 174.234 229.479C174.295 229.442 174.357 229.401 174.419 229.359C174.48 229.07 174.538 228.781 174.569 228.488C174.604 228.151 174.633 227.762 174.536 227.419Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M176.888 229.701C176.888 229.701 176.897 229.696 176.901 229.694C176.957 229.662 177.012 229.625 177.065 229.59C177.12 229.336 177.17 229.079 177.199 228.821C177.243 228.416 177.274 227.923 177.032 227.567C176.842 227.286 176.522 227.186 176.236 227.378C175.931 227.58 175.731 227.932 175.568 228.247C175.515 228.349 175.468 228.453 175.422 228.558C175.299 228.966 175.239 229.418 175.449 229.581C175.515 229.633 175.603 229.651 175.687 229.664C175.975 229.707 176.502 229.792 176.89 229.701H176.888Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M177.032 227.564C177.01 227.532 176.985 227.501 176.959 227.473C176.981 227.636 177.001 227.801 177.005 227.964C177.014 228.318 176.985 228.712 176.796 229.023C176.588 229.364 176.207 229.503 175.817 229.442C175.541 229.399 175.391 229.268 175.316 229.094C175.301 229.307 175.334 229.49 175.449 229.581C175.515 229.633 175.603 229.651 175.687 229.664C175.976 229.707 176.502 229.792 176.891 229.701C176.895 229.698 176.899 229.696 176.904 229.694C176.959 229.661 177.014 229.625 177.067 229.59C177.122 229.336 177.173 229.079 177.201 228.82C177.245 228.416 177.276 227.923 177.034 227.567L177.032 227.564Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M170.717 229.188C170.856 229.227 170.997 229.255 171.138 229.279C171.341 229.253 171.526 229.199 171.656 229.088C171.738 228.76 171.8 228.425 171.826 228.09C171.861 227.647 171.859 227.145 171.608 226.76C171.489 226.576 171.352 226.517 171.195 226.56C171.105 226.623 171.019 226.691 170.937 226.763C170.814 226.871 170.697 226.986 170.585 227.108C170.353 227.523 170.155 227.958 170.062 228.418C170.038 228.545 170.02 228.69 170.031 228.827C170.214 229.007 170.466 229.118 170.717 229.19V229.188Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M171.608 226.758C171.564 226.689 171.515 226.643 171.467 226.608C171.531 226.784 171.562 226.975 171.581 227.158C171.612 227.447 171.603 227.738 171.562 228.025C171.526 228.262 171.467 228.518 171.33 228.72C171.14 229.001 170.836 229.101 170.508 229.049C170.417 229.033 170.329 229.01 170.241 228.981C170.389 229.073 170.552 229.14 170.717 229.188C170.856 229.227 170.997 229.255 171.138 229.279C171.341 229.253 171.526 229.199 171.656 229.088C171.738 228.76 171.8 228.425 171.826 228.09C171.861 227.647 171.859 227.145 171.608 226.76V226.758Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M140.879 175.459C140.154 171.826 139.009 168.349 137.241 165.074C135.773 162.358 133.965 159.532 131.18 157.977C128.724 156.605 125.728 155.869 122.939 156.56C119.951 157.301 117.792 159.674 116.807 162.488C116.436 163.546 116.229 164.657 116.152 165.78C115.971 166.804 115.896 167.851 115.934 168.901C116.099 173.64 118.61 177.787 120.286 182.118C122.118 186.857 123.128 191.916 123.922 196.912C124.722 201.954 125.243 207.033 125.897 212.094C126.519 216.894 127.209 221.688 127.461 226.524C127.364 227.006 127.39 227.519 127.189 227.982C126.929 228.581 126.457 229.073 126.241 229.692C126.102 230.092 126.083 230.542 126.327 230.909C127.159 232.163 134.324 231.613 136.32 231C137.464 230.648 138.28 230.037 138.403 228.812C138.599 226.871 138.379 225.035 138.379 223.096C138.189 218.972 138.152 214.847 138.247 210.721C138.339 206.683 138.606 202.652 139.267 198.664C139.909 194.798 140.709 190.956 141.157 187.059C141.602 183.185 141.646 179.299 140.879 175.459Z",
    fill: "#FA9621"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M129.784 231.467C129.784 231.467 129.798 231.45 129.802 231.441C129.857 231.359 129.884 231.261 129.908 231.167C130.001 230.82 130.091 230.47 130.113 230.113C130.309 226.912 126.832 230.907 127.76 231.561C127.813 231.6 127.884 231.609 127.948 231.617C128.365 231.672 129.467 231.869 129.782 231.469L129.784 231.467Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M129.835 228.96C129.906 229.351 129.857 229.764 129.773 230.148C129.705 230.47 129.61 230.855 129.381 231.107C129.112 231.402 128.6 231.485 128.219 231.472C128.007 231.465 127.793 231.417 127.617 231.322C127.637 231.42 127.681 231.502 127.76 231.559C127.813 231.596 127.884 231.606 127.948 231.615C128.364 231.669 129.467 231.867 129.782 231.467C129.789 231.459 129.795 231.45 129.8 231.441C129.855 231.359 129.881 231.261 129.906 231.167C129.998 230.82 130.089 230.47 130.111 230.114C130.15 229.451 130.033 229.101 129.831 228.962L129.835 228.96Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M126.945 231.426C127.229 231.07 127.485 230.687 127.652 230.263C127.807 229.868 127.939 229.418 127.932 228.99C127.926 228.631 127.741 228.258 127.372 228.242C127.086 228.392 126.823 228.631 126.62 228.847C126.402 229.077 126.204 229.338 126.047 229.614C125.88 229.907 125.734 230.257 125.789 230.6C125.869 231.109 126.449 231.522 126.947 231.426H126.945Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M127.626 228.325C127.65 228.51 127.666 228.697 127.668 228.881C127.67 229.268 127.621 229.666 127.48 230.029C127.348 230.366 127.123 230.755 126.79 230.935C126.44 231.126 126.078 230.983 125.822 230.715C125.966 231.167 126.488 231.513 126.947 231.424C127.231 231.067 127.487 230.685 127.655 230.261C127.809 229.866 127.941 229.416 127.935 228.988C127.93 228.725 127.827 228.455 127.628 228.323L127.626 228.325Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M181.759 201.317C183.703 201.12 185.641 200.855 187.577 200.568C187.804 200.337 188.027 200.101 188.245 199.861C190.077 197.847 191.48 195.535 192.472 193.016C194.774 187.177 195.493 180.794 193.872 174.69C193.058 171.624 191.722 168.71 189.932 166.078C180.491 152.194 164.213 144.138 148.322 139.666C143.924 138.427 139.364 137.325 134.772 137.195C128.448 137.015 122.971 139.451 118.37 143.638C115.74 146.033 113.552 148.869 111.778 151.927C110.865 153.5 110.058 155.136 109.354 156.812C108.922 157.842 108.539 158.881 108.226 159.941C107.403 164.426 107.445 168.999 108.916 173.438C111.407 180.966 117.706 186.06 125.366 188.02C126.398 188.283 127.46 188.507 128.541 188.683C128.664 188.798 128.781 188.915 128.907 189.028C129.912 189.937 130.966 190.784 132.062 191.578C132.474 192.04 132.895 192.495 133.33 192.934C136.987 196.637 141.203 199.679 145.972 201.841C151.352 204.279 157.232 205.638 163.172 205.351C169.114 205.064 175.124 203.532 180.694 201.415C181.049 201.387 181.404 201.354 181.759 201.317Z",
    fill: "url(#paint17_linear_6036_31799)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 147.739C114.536 147.85 114.472 147.961 114.412 148.074C114.745 147.576 115.107 147.098 115.49 146.637C115.184 146.998 114.889 147.367 114.598 147.739Z",
    fill: "#6960A1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M193.698 188.037C193.517 187.02 193.495 185.988 193.477 184.958C193.396 184.491 193.31 184.024 193.217 183.559C192.558 180.223 191.55 176.924 189.663 174.119C189.672 174.192 189.683 174.268 189.692 174.342C189.95 176.763 189.707 179.23 189.16 181.598C188.578 184.117 187.63 186.564 186.365 188.826C185.13 191.034 183.573 193.096 181.671 194.789C179.889 196.376 177.783 197.638 175.453 198.253C173.861 198.675 172.126 198.74 170.646 197.932C169.343 197.221 168.464 195.965 167.893 194.639C167.194 193.018 166.876 191.254 166.713 189.506C166.532 187.561 166.561 185.597 166.711 183.65C166.836 182.016 167.057 180.386 167.368 178.776C167.013 179.784 166.7 180.807 166.404 181.831C165.902 183.574 165.412 185.317 164.969 187.075C164.663 188.294 164.343 189.517 163.886 190.691C163.512 191.653 163.06 192.599 162.341 193.359C159.693 196.161 155.131 195.343 151.762 194.668C150.192 194.353 148.547 193.868 147.324 192.799C146.213 191.827 145.688 190.456 145.516 189.031C145.273 187.003 145.608 184.919 145.604 182.883C145.6 180.892 145.434 178.767 144.471 176.983C144.367 179.803 144.297 182.659 143.397 185.362C143.331 185.56 143.051 185.517 143.038 185.314C142.848 182.468 143.051 179.617 142.958 176.768C142.868 173.962 142.37 171.257 141.289 168.651C139.841 165.157 137.556 161.766 134.13 159.904C130.821 158.107 126.332 157.748 123.254 160.191C120.332 162.51 119.113 166.489 119.166 170.072C119.236 175.001 121.247 179.493 123.265 183.908C123.329 184.048 123.225 184.213 123.057 184.174C120.431 183.537 117.969 182.346 115.912 180.607C112.693 177.889 110.73 174.04 110.011 169.966C109.63 168.751 109.363 167.501 109.191 166.241C108.947 164.442 108.898 162.616 109.022 160.806C109.136 159.115 109.399 157.431 109.809 155.786C109.654 156.125 109.504 156.466 109.361 156.81C108.929 157.84 108.545 158.878 108.232 159.939C107.41 164.424 107.452 168.996 108.922 173.436C111.414 180.964 117.713 186.058 125.373 188.018C126.404 188.281 127.467 188.505 128.547 188.681C128.671 188.796 128.788 188.913 128.913 189.026C129.919 189.935 130.973 190.782 132.069 191.575C132.481 192.038 132.902 192.492 133.336 192.931C136.994 196.634 141.21 199.677 145.979 201.839C151.359 204.277 157.239 205.635 163.179 205.349C169.121 205.062 175.131 203.53 180.7 201.413C181.055 201.385 181.41 201.352 181.765 201.315C183.71 201.117 185.648 200.852 187.584 200.565C187.811 200.335 188.034 200.098 188.252 199.859C190.084 197.845 191.486 195.533 192.479 193.014C193.034 191.601 193.497 190.156 193.859 188.692C193.797 188.476 193.744 188.259 193.704 188.037H193.698Z",
    fill: "#FFCC00"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M144.433 176.574C143.708 172.941 142.564 169.464 140.795 166.189C139.327 163.472 137.519 160.647 134.734 159.091C132.278 157.72 129.282 156.983 126.493 157.674C123.505 158.416 121.346 160.789 120.361 163.603C119.991 164.661 119.783 165.772 119.706 166.895C119.525 167.919 119.45 168.966 119.488 170.016C119.653 174.755 122.164 178.902 123.84 183.233C125.672 187.972 126.682 193.031 127.476 198.027C128.276 203.069 128.797 208.148 129.451 213.209C130.073 218.009 130.763 222.803 131.015 227.638C130.918 228.121 130.944 228.634 130.743 229.097C130.483 229.696 130.011 230.187 129.795 230.807C129.656 231.207 129.637 231.657 129.881 232.024C130.713 233.275 137.878 232.728 139.874 232.115C141.018 231.763 141.834 231.155 141.957 229.927C142.153 227.986 141.933 226.15 141.933 224.211C141.743 220.087 141.706 215.962 141.801 211.835C141.893 207.798 142.16 203.767 142.822 199.779C143.463 195.913 144.263 192.071 144.711 188.174C145.156 184.3 145.201 180.414 144.433 176.576V176.574Z",
    fill: "url(#paint18_linear_6036_31799)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144.433 176.574C143.708 172.941 142.563 169.464 140.795 166.189C140.081 164.865 139.283 163.518 138.332 162.303C140.041 165.041 141.212 168.114 141.959 171.239C143.168 176.298 143.366 181.581 142.918 186.747C142.669 189.615 142.145 192.434 141.62 195.263C140.958 198.829 140.308 202.406 140.008 206.025C139.71 209.625 139.882 213.194 140.303 216.779C140.667 219.883 141.113 222.975 141.371 226.089C141.503 227.699 141.56 229.772 141.08 231.533C141.565 231.163 141.884 230.655 141.957 229.925C142.153 227.984 141.933 226.148 141.933 224.209C141.743 220.085 141.706 215.96 141.801 211.833C141.893 207.796 142.16 203.764 142.821 199.777C143.463 195.911 144.263 192.069 144.711 188.172C145.156 184.298 145.2 180.41 144.433 176.574Z",
    fill: "url(#paint19_linear_6036_31799)"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M133.338 232.582C133.338 232.582 133.352 232.565 133.356 232.556C133.411 232.474 133.438 232.376 133.462 232.282C133.555 231.935 133.645 231.585 133.667 231.228C133.863 228.027 130.386 232.022 131.314 232.676C131.367 232.713 131.438 232.724 131.502 232.732C131.919 232.787 133.021 232.984 133.336 232.584L133.338 232.582Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M133.389 230.075C133.46 230.466 133.411 230.879 133.327 231.263C133.259 231.585 133.162 231.97 132.935 232.222C132.666 232.517 132.154 232.6 131.773 232.587C131.561 232.58 131.348 232.532 131.171 232.437C131.191 232.535 131.235 232.617 131.314 232.674C131.367 232.711 131.438 232.721 131.502 232.73C131.919 232.784 133.021 232.982 133.336 232.582C133.343 232.574 133.35 232.565 133.354 232.556C133.409 232.474 133.435 232.376 133.46 232.282C133.552 231.935 133.643 231.585 133.665 231.228C133.704 230.566 133.588 230.216 133.385 230.075H133.389Z",
    fill: "white"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M130.499 232.541C130.783 232.185 131.039 231.802 131.206 231.378C131.361 230.983 131.493 230.533 131.486 230.105C131.48 229.748 131.295 229.373 130.926 229.357C130.64 229.507 130.377 229.746 130.174 229.961C129.956 230.192 129.758 230.453 129.601 230.729C129.434 231.022 129.288 231.372 129.343 231.715C129.423 232.224 130.003 232.637 130.501 232.541H130.499Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M131.18 229.44C131.204 229.625 131.22 229.812 131.222 229.996C131.224 230.383 131.176 230.781 131.034 231.144C130.902 231.48 130.677 231.869 130.344 232.05C129.994 232.241 129.632 232.098 129.376 231.83C129.52 232.282 130.042 232.628 130.501 232.539C130.785 232.182 131.041 231.8 131.209 231.376C131.363 230.981 131.495 230.531 131.489 230.103C131.484 229.84 131.381 229.57 131.182 229.438L131.18 229.44Z",
    fill: "white"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M191.835 180.775C191.354 175.305 187.961 170.292 182.422 168.736C174.611 166.541 167.69 171.958 166.074 179.314C164.389 186.975 165.401 195.052 166.845 202.682C167.718 207.293 168.922 211.844 170.446 216.288C171.747 220.087 175.204 225.065 174.498 229.164C174.388 229.803 173.943 230.376 173.949 231.039C173.958 232.076 175.179 232.306 176.008 232.371C177.4 232.48 178.791 232.593 180.184 232.684C181.662 232.784 183.152 232.828 184.627 232.66C185.846 232.521 187.207 232.258 188.236 231.556C189.218 230.887 189.581 229.785 189.33 228.651C189.167 227.919 188.799 227.256 188.519 226.563C188.499 226.513 188.483 226.463 188.464 226.415C188.384 225.917 188.283 225.422 188.197 224.926C186.715 216.297 185.073 208.315 187.734 199.709C189.601 193.67 192.404 187.201 191.839 180.768L191.835 180.775Z",
    fill: "url(#paint20_linear_6036_31799)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M177.772 232.671C177.772 232.671 177.781 232.665 177.788 232.663C177.849 232.626 177.911 232.584 177.973 232.543C178.035 232.254 178.092 231.967 178.123 231.672C178.171 231.213 178.207 230.655 177.933 230.253C177.717 229.935 177.358 229.822 177.032 230.04C176.688 230.268 176.46 230.668 176.275 231.024C176.216 231.139 176.165 231.257 176.112 231.376C175.971 231.839 175.907 232.347 176.141 232.534C176.216 232.593 176.315 232.613 176.41 232.628C176.736 232.678 177.334 232.773 177.77 232.669L177.772 232.671Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M178.09 230.605C178.099 230.705 178.105 230.802 178.105 230.902C178.105 231.281 178.028 231.687 177.792 231.993C177.523 232.341 177.122 232.421 176.699 232.428C176.456 232.43 176.2 232.395 176.004 232.265C176.024 232.382 176.068 232.478 176.143 232.539C176.218 232.597 176.317 232.617 176.412 232.632C176.738 232.682 177.336 232.778 177.772 232.674C177.777 232.671 177.781 232.667 177.788 232.665C177.85 232.628 177.911 232.587 177.973 232.545C178.035 232.256 178.092 231.969 178.123 231.674C178.158 231.337 178.187 230.948 178.09 230.605Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M180.442 232.884C180.442 232.884 180.451 232.88 180.456 232.878C180.511 232.845 180.566 232.808 180.619 232.773C180.674 232.519 180.725 232.263 180.751 232.004C180.795 231.6 180.826 231.107 180.583 230.75C180.394 230.47 180.074 230.37 179.788 230.561C179.483 230.763 179.283 231.115 179.119 231.43C179.067 231.533 179.02 231.637 178.974 231.741C178.85 232.15 178.791 232.602 179 232.765C179.067 232.817 179.155 232.834 179.239 232.847C179.527 232.891 180.054 232.976 180.442 232.884Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M180.586 230.75C180.564 230.718 180.539 230.687 180.513 230.659C180.535 230.822 180.555 230.987 180.559 231.15C180.568 231.504 180.539 231.898 180.35 232.208C180.143 232.55 179.761 232.689 179.371 232.628C179.095 232.584 178.945 232.454 178.87 232.28C178.855 232.493 178.888 232.676 179.003 232.767C179.069 232.819 179.157 232.836 179.241 232.85C179.53 232.893 180.057 232.978 180.445 232.886C180.449 232.884 180.453 232.882 180.458 232.88C180.513 232.847 180.568 232.81 180.621 232.776C180.676 232.521 180.727 232.265 180.753 232.006C180.797 231.602 180.828 231.109 180.586 230.752V230.75Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M174.273 232.371C174.412 232.411 174.553 232.439 174.694 232.463C174.897 232.437 175.082 232.382 175.212 232.271C175.294 231.943 175.356 231.609 175.382 231.274C175.418 230.831 175.415 230.329 175.164 229.944C175.045 229.761 174.908 229.701 174.752 229.744C174.661 229.807 174.575 229.874 174.494 229.946C174.37 230.055 174.253 230.17 174.141 230.292C173.909 230.707 173.711 231.141 173.618 231.602C173.594 231.728 173.577 231.874 173.588 232.011C173.771 232.191 174.022 232.302 174.273 232.374V232.371Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M175.162 229.942C175.118 229.872 175.069 229.827 175.021 229.792C175.085 229.968 175.115 230.161 175.135 230.342C175.166 230.631 175.157 230.922 175.115 231.209C175.08 231.446 175.021 231.702 174.884 231.904C174.694 232.185 174.39 232.285 174.062 232.232C173.971 232.217 173.883 232.193 173.795 232.165C173.943 232.256 174.106 232.324 174.271 232.371C174.41 232.411 174.551 232.439 174.692 232.463C174.895 232.437 175.08 232.382 175.21 232.272C175.292 231.943 175.354 231.609 175.38 231.274C175.415 230.831 175.413 230.329 175.162 229.944V229.942Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M129.936 149.18C129.978 148.858 129.809 148.558 129.632 148.304C129.593 148.267 129.555 148.228 129.515 148.191C129.443 148.141 129.361 148.113 129.275 148.108C129.218 148.1 129.158 148.104 129.101 148.108C129.032 148.052 128.924 148.048 128.843 148.056C128.744 148.065 128.622 148.102 128.545 148.167C128.481 148.221 128.411 148.271 128.356 148.332C128.305 148.391 128.256 148.454 128.212 148.515C128.144 148.61 128.091 148.715 128.04 148.821C127.965 148.982 127.917 149.167 127.915 149.345C127.915 149.543 127.952 149.716 128.034 149.895C128.131 150.105 128.261 150.253 128.431 150.414C128.528 150.507 128.766 150.507 128.885 150.479C129.063 150.436 129.253 150.349 129.372 150.205C129.379 150.197 129.385 150.19 129.392 150.182C129.41 150.173 129.429 150.166 129.447 150.155C129.458 150.149 129.469 150.142 129.48 150.136C129.491 150.132 129.507 150.125 129.531 150.11C129.537 150.105 129.54 150.101 129.546 150.097C129.588 150.069 129.628 150.036 129.665 149.997C129.667 149.992 129.672 149.99 129.676 149.988H129.678C129.72 149.942 129.756 149.897 129.789 149.847C129.813 149.806 129.837 149.756 129.857 149.703C129.857 149.701 129.859 149.697 129.861 149.695C129.87 149.675 129.879 149.656 129.884 149.636C129.901 149.573 129.925 149.477 129.928 149.432C129.93 149.382 129.923 149.332 129.914 149.284C129.921 149.249 129.936 149.219 129.941 149.182L129.936 149.18Z",
    fill: "url(#paint21_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M131.985 150.701C131.464 150.701 130.977 151.614 131.667 151.614C132.187 151.614 132.675 150.701 131.985 150.701Z",
    fill: "url(#paint22_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M136.249 153.639C136.249 153.639 136.249 153.635 136.249 153.632C136.249 153.626 136.249 153.619 136.249 153.611C136.249 153.595 136.238 153.456 136.233 153.443C136.233 153.439 136.231 153.437 136.229 153.433C136.229 153.426 136.225 153.419 136.222 153.413C136.218 153.4 136.214 153.385 136.211 153.372C136.209 153.359 136.205 153.348 136.203 153.335V153.326C136.196 153.306 136.145 153.193 136.132 153.176C136.13 153.172 136.125 153.167 136.123 153.163C136.117 153.154 136.11 153.146 136.106 153.137L136.101 153.128C136.084 153.111 136.066 153.091 136.046 153.076C136.028 153.059 136.011 153.041 135.991 153.024C135.945 153.002 135.896 152.98 135.85 152.959H135.843C135.843 152.959 135.837 152.952 135.834 152.95C135.817 152.937 135.799 152.924 135.777 152.915C135.733 152.894 135.671 152.859 135.616 152.85C135.543 152.831 135.468 152.831 135.396 152.846C135.332 152.857 135.272 152.881 135.219 152.915C135.16 152.944 135.105 152.983 135.061 153.033C135.003 153.091 134.961 153.157 134.935 153.233C134.924 153.272 134.911 153.311 134.897 153.352C134.88 153.376 134.862 153.398 134.86 153.402C134.858 153.406 134.855 153.411 134.853 153.413C134.822 153.472 134.783 153.546 134.756 153.615C134.743 153.645 134.743 153.672 134.734 153.711C134.723 153.765 134.717 153.772 134.717 153.806C134.717 153.817 134.717 153.826 134.717 153.837C134.725 153.971 134.723 154.147 134.827 154.254C134.869 154.297 134.913 154.341 134.959 154.382C134.966 154.387 134.972 154.393 134.979 154.397C134.981 154.397 134.986 154.402 134.988 154.404H134.992C135.014 154.419 135.113 154.465 135.138 154.473H135.146C135.146 154.473 135.31 154.5 135.314 154.5C135.314 154.5 135.318 154.5 135.321 154.5C135.38 154.493 135.44 154.489 135.499 154.482C135.561 154.463 135.623 154.443 135.684 154.423C135.744 154.391 135.806 154.356 135.865 154.323C135.951 154.267 136.024 154.197 136.081 154.115C136.125 154.069 136.159 154.019 136.181 153.958C136.211 153.908 136.231 153.856 136.236 153.798C136.256 153.745 136.258 153.693 136.247 153.641L136.249 153.639Z",
    fill: "url(#paint23_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M153.943 148.91C153.797 148.839 153.647 148.793 153.495 148.76C153.48 148.743 153.469 148.723 153.453 148.706C153.332 148.573 153.193 148.493 153.017 148.447C152.15 148.224 151.297 148.789 150.821 149.46C150.329 150.153 150.21 151.075 150.679 151.807C151.105 152.47 151.912 152.778 152.684 152.646C153.746 152.461 154.494 151.488 154.679 150.488C154.794 149.869 154.531 149.201 153.943 148.912V148.91Z",
    fill: "url(#paint24_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M158.795 163.946C158.306 163.946 157.85 164.802 158.498 164.802C158.987 164.802 159.444 163.946 158.795 163.946Z",
    fill: "url(#paint25_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M155.925 163.299C155.755 162.41 155.098 161.688 154.121 162.329C153.852 162.505 153.687 162.803 153.581 163.105C153.338 163.807 153.391 164.915 154.251 165.18C155.656 165.613 156.123 164.339 155.922 163.296L155.925 163.299Z",
    fill: "url(#paint26_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M163.408 169.798C163.388 169.738 163.348 169.688 163.291 169.653C163.251 169.635 163.212 169.616 163.172 169.598C163.077 169.572 162.98 169.572 162.883 169.594C162.832 169.611 162.779 169.627 162.729 169.644C162.621 169.692 162.526 169.757 162.447 169.84L162.286 169.998C162.226 170.055 162.182 170.118 162.153 170.192C162.116 170.253 162.096 170.322 162.092 170.394C162.083 170.461 162.096 170.524 162.129 170.581C162.149 170.642 162.189 170.692 162.246 170.726C162.286 170.744 162.325 170.763 162.365 170.781C162.46 170.805 162.557 170.807 162.654 170.785C162.705 170.768 162.757 170.752 162.808 170.735C162.916 170.687 163.011 170.622 163.09 170.539L163.251 170.381C163.311 170.324 163.355 170.261 163.384 170.187C163.421 170.127 163.441 170.059 163.445 169.985C163.454 169.918 163.441 169.855 163.408 169.798Z",
    fill: "url(#paint27_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M169.405 167.169C169.396 167.136 169.378 167.112 169.352 167.093C169.321 167.056 169.279 167.03 169.229 167.019C169.218 167.015 169.204 167.008 169.193 167.004L169.178 166.997C169.178 166.997 169.171 166.995 169.167 166.993L169.057 166.978C169.015 166.982 168.975 166.986 168.933 166.991C168.867 167.004 168.805 167.028 168.75 167.062C168.728 167.073 168.708 167.086 168.688 167.097L168.68 167.101C168.68 167.101 168.669 167.108 168.664 167.11L168.631 167.128C168.565 167.173 168.51 167.23 168.466 167.297C168.435 167.34 168.415 167.388 168.408 167.44C168.393 167.486 168.393 167.532 168.408 167.58C168.424 167.64 168.459 167.688 168.512 167.723C168.521 167.729 168.527 167.738 168.536 167.745L168.547 167.753L168.554 167.76C168.598 167.801 168.704 167.821 168.761 167.821C168.783 167.823 168.803 167.821 168.825 167.814C168.889 167.814 168.951 167.797 169.008 167.769L169.019 167.764L169.039 167.758C169.052 167.753 169.068 167.749 169.081 167.745C169.118 167.723 169.156 167.703 169.193 167.682L169.293 167.599C169.317 167.569 169.341 167.536 169.367 167.506C169.401 167.46 169.42 167.41 169.427 167.356C169.438 167.323 169.44 167.29 169.434 167.258C169.436 167.225 169.429 167.195 169.409 167.167L169.405 167.169Z",
    fill: "url(#paint28_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M148.666 168.379C148.653 168.342 148.644 168.301 148.638 168.262C148.62 168.173 148.611 168.105 148.556 168.023C148.497 167.932 148.4 167.856 148.292 167.829C148.276 167.825 148.159 167.81 148.142 167.808C148.087 167.803 148.031 167.812 147.979 167.823C147.802 167.858 147.635 167.956 147.511 168.084C147.434 168.162 147.37 168.26 147.333 168.364C147.315 168.412 147.308 168.464 147.299 168.516V168.538C147.299 168.553 147.293 168.568 147.293 168.586C147.293 168.61 147.288 168.636 147.286 168.66C147.282 168.714 147.277 168.768 147.28 168.823C147.271 168.925 147.297 169.02 147.355 169.107C147.39 169.142 147.425 169.177 147.46 169.212C147.551 169.268 147.652 169.299 147.76 169.299C147.853 169.303 147.941 169.285 148.025 169.253C148.122 169.229 148.21 169.186 148.292 169.127C148.294 169.127 148.296 169.122 148.298 169.122C148.338 169.114 148.375 169.101 148.408 169.079C148.475 169.042 148.543 168.99 148.58 168.923C148.594 168.896 148.605 168.873 148.618 168.846C148.633 168.803 148.636 168.76 148.629 168.716C148.631 168.707 148.636 168.701 148.64 168.694C148.677 168.594 148.684 168.492 148.66 168.388L148.666 168.379Z",
    fill: "url(#paint29_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M114.404 162.672C114.398 162.627 114.404 162.672 114.404 162.672V162.672Z",
    fill: "url(#paint30_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M115.669 162.255C115.658 162.201 115.629 162.158 115.588 162.125C115.565 162.095 115.537 162.075 115.502 162.066C115.451 162.038 115.398 162.025 115.338 162.027C115.296 162.032 115.255 162.036 115.215 162.04C115.142 162.055 115.076 162.086 115.012 162.123C114.986 162.125 114.961 162.127 114.935 162.129H114.93L114.919 162.134C114.908 162.136 114.897 162.138 114.884 162.14C114.851 162.151 114.818 162.162 114.787 162.171C114.774 162.175 114.701 162.218 114.69 162.225C114.677 162.234 114.591 162.308 114.646 162.262C114.628 162.277 114.606 162.295 114.589 162.312C114.584 162.316 114.582 162.318 114.578 162.323C114.547 162.358 114.518 162.397 114.49 162.434L114.485 162.44C114.467 162.479 114.448 162.518 114.43 162.555C114.421 162.592 114.415 162.631 114.406 162.668C114.406 162.673 114.406 162.673 114.406 162.673C114.406 162.684 114.408 162.699 114.41 162.727C114.41 162.744 114.412 162.764 114.415 162.781C114.43 162.814 114.445 162.846 114.459 162.879C114.459 162.881 114.463 162.886 114.465 162.888C114.465 162.89 114.47 162.892 114.472 162.896H114.474C114.485 162.912 114.54 162.964 114.553 162.975C114.558 162.979 114.562 162.983 114.569 162.986L114.576 162.99C114.576 162.99 114.668 163.033 114.679 163.038C114.717 163.051 114.761 163.053 114.8 163.055C114.807 163.055 114.811 163.055 114.818 163.055C114.864 163.053 114.915 163.051 114.961 163.04C114.964 163.04 114.968 163.04 114.97 163.038C114.994 163.031 115.025 163.02 115.041 163.016C115.058 163.012 115.089 163.003 115.111 162.994C115.118 162.992 115.125 162.99 115.131 162.986C115.18 162.962 115.228 162.933 115.277 162.905C115.292 162.896 115.305 162.886 115.319 162.877C115.389 162.82 115.46 162.762 115.521 162.697C115.57 162.651 115.605 162.597 115.632 162.538C115.662 162.488 115.678 162.431 115.682 162.371C115.68 162.336 115.676 162.299 115.674 162.264L115.669 162.255Z",
    fill: "url(#paint31_linear_6036_31799)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M118.026 159.4C118.026 159.4 118.017 159.387 118.013 159.38C118.05 159.33 118.083 159.276 118.083 159.215C118.083 159.141 118.057 159.091 118.002 159.041C117.909 158.959 117.81 158.883 117.7 158.826C117.592 158.772 117.488 158.707 117.371 158.674C117.263 158.644 117.146 158.626 117.034 158.635C116.88 158.648 116.727 158.674 116.588 158.746C116.478 158.802 116.394 158.854 116.304 158.933C116.234 158.991 116.183 159.05 116.128 159.115C116.097 159.154 116.062 159.191 116.039 159.235C116.009 159.291 115.98 159.348 115.956 159.409C115.925 159.485 115.912 159.569 115.896 159.648C115.874 159.772 115.887 159.906 115.914 160.03C115.942 160.167 116.009 160.302 116.081 160.421C116.172 160.571 116.3 160.693 116.428 160.812C116.496 160.86 116.573 160.886 116.655 160.891C116.743 160.91 116.831 160.908 116.921 160.884C116.983 160.865 117.047 160.845 117.109 160.823C117.186 160.789 117.254 160.745 117.32 160.697C117.382 160.645 117.446 160.599 117.51 160.55C117.523 160.541 117.534 160.53 117.548 160.519C117.589 160.489 117.627 160.454 117.669 160.423C117.768 160.36 117.85 160.28 117.916 160.187C117.986 160.108 118.039 160.019 118.072 159.917C118.086 159.856 118.099 159.795 118.11 159.732C118.119 159.613 118.09 159.502 118.022 159.402L118.026 159.4Z",
    fill: "url(#paint32_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M116.064 159.186C116.086 159.157 116.106 159.135 116.126 159.111C116.139 159.096 116.148 159.081 116.161 159.063C116.13 159.105 116.097 159.144 116.064 159.186Z",
    fill: "url(#paint33_linear_6036_31799)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M120.989 158.374C120.5 158.374 120.043 159.23 120.692 159.23C121.181 159.23 121.637 158.374 120.989 158.374Z",
    fill: "url(#paint34_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M116.304 150.353C116.28 150.331 116.258 150.308 116.233 150.286C116.216 150.24 116.192 150.199 116.152 150.168C116.11 150.118 116.055 150.086 115.989 150.071C115.98 150.071 115.973 150.066 115.964 150.064C115.953 150.062 115.848 150.047 115.837 150.047C115.764 150.045 115.695 150.055 115.629 150.084C115.554 150.103 115.484 150.136 115.42 150.184L115.413 150.188C115.413 150.188 115.407 150.192 115.402 150.197C115.363 150.229 115.312 150.271 115.272 150.305H115.27V150.312C115.235 150.353 115.202 150.394 115.169 150.438C115.127 150.499 115.1 150.566 115.089 150.638C115.078 150.66 115.074 150.684 115.076 150.707C115.08 150.751 115.083 150.792 115.087 150.836C115.098 150.883 115.111 150.92 115.142 150.951C115.173 150.981 115.204 151.014 115.237 151.042C115.243 151.049 115.25 151.053 115.259 151.057L115.272 151.07L115.277 151.075C115.277 151.075 115.288 151.083 115.292 151.086C115.332 151.107 115.376 151.129 115.42 151.144C115.426 151.146 115.433 151.149 115.44 151.149C115.488 151.157 115.537 151.168 115.587 151.168C115.596 151.168 115.603 151.168 115.612 151.168C115.671 151.164 115.742 151.162 115.801 151.144C115.876 151.131 115.942 151.103 116.006 151.064C116.077 151.031 116.139 150.986 116.189 150.927L116.278 150.814C116.315 150.76 116.339 150.699 116.348 150.636C116.361 150.597 116.366 150.56 116.355 150.518C116.355 150.46 116.339 150.408 116.302 150.36L116.304 150.353Z",
    fill: "url(#paint35_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M148.102 174.946C148.045 174.866 147.976 174.801 147.901 174.731C147.886 174.718 147.873 174.705 147.855 174.694C147.851 174.692 147.848 174.69 147.844 174.688C147.826 174.679 147.793 174.664 147.762 174.649C147.727 174.629 147.692 174.614 147.654 174.603H147.65C147.65 174.603 147.482 174.577 147.474 174.577C147.467 174.577 147.46 174.577 147.452 174.577H147.465C147.465 174.577 147.454 174.577 147.445 174.577C147.394 174.577 147.343 174.586 147.293 174.592C147.284 174.592 147.273 174.592 147.271 174.594C147.205 174.616 147.141 174.636 147.074 174.657C147.011 174.692 146.947 174.729 146.883 174.764H146.88L146.713 174.907L146.708 174.912C146.708 174.912 146.702 174.918 146.7 174.92L146.695 174.925C146.653 174.979 146.609 175.031 146.567 175.086L146.563 175.09C146.563 175.09 146.556 175.099 146.554 175.103C146.537 175.131 146.521 175.17 146.51 175.194C146.475 175.246 146.455 175.305 146.451 175.366C146.44 175.394 146.435 175.425 146.433 175.455C146.433 175.462 146.446 175.616 146.448 175.622V175.629C146.448 175.629 146.453 175.638 146.455 175.644C146.484 175.751 146.543 175.835 146.636 175.898C146.733 175.959 146.841 175.99 146.955 175.992C147.046 175.992 147.132 175.974 147.218 175.95C147.299 175.968 147.379 175.966 147.46 175.944C147.518 175.924 147.577 175.907 147.635 175.887C147.727 175.851 147.809 175.798 147.881 175.729C147.934 175.692 147.978 175.648 148.012 175.594C148.071 175.529 148.115 175.455 148.142 175.37C148.153 175.32 148.164 175.268 148.175 175.218C148.184 175.118 148.159 175.027 148.102 174.942V174.946Z",
    fill: "url(#paint36_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M148.164 182.331C147.857 182.331 147.526 182.544 147.429 182.837C147.341 183.107 147.504 183.363 147.804 183.363C148.104 183.363 148.441 183.15 148.538 182.857C148.627 182.587 148.464 182.331 148.164 182.331Z",
    fill: "url(#paint37_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M164.21 177.672C164.182 177.65 164.153 177.632 164.124 177.615L164.129 177.606C164.142 177.541 164.155 177.476 164.171 177.411C164.184 177.313 164.164 177.222 164.116 177.141C164.098 177.078 164.065 177.031 164.01 176.994C163.948 176.92 163.869 176.872 163.772 176.85C163.705 176.841 163.637 176.831 163.571 176.822L163.353 176.844C163.231 176.865 163.119 176.911 163.018 176.976C162.903 177.031 162.801 177.104 162.715 177.2C162.656 177.27 162.592 177.339 162.548 177.417C162.471 177.548 162.416 177.678 162.405 177.832C162.4 177.913 162.402 178.002 162.433 178.078C162.449 178.115 162.495 178.219 162.515 178.254C162.535 178.289 162.548 178.291 162.59 178.332C162.632 178.374 162.649 178.391 162.691 178.417C162.726 178.437 162.76 178.458 162.79 178.48C162.887 178.541 162.993 178.571 163.108 178.571C163.24 178.571 163.366 178.545 163.485 178.493C163.635 178.428 163.776 178.321 163.884 178.191C163.91 178.191 163.939 178.191 163.963 178.187C164.045 178.169 164.138 178.119 164.195 178.058C164.246 178.002 164.296 177.928 164.296 177.85C164.296 177.778 164.274 177.719 164.215 177.676L164.21 177.672Z",
    fill: "url(#paint38_linear_6036_31799)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M162.432 178.078C162.424 178.058 162.422 178.053 162.432 178.078V178.078Z",
    fill: "url(#paint39_linear_6036_31799)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M175.151 166.384C175.131 166.31 175.089 166.252 175.025 166.208C174.957 166.165 174.882 166.143 174.802 166.143C174.71 166.143 174.622 166.16 174.538 166.2C174.498 166.213 174.456 166.228 174.417 166.241C174.377 166.263 174.337 166.284 174.298 166.306C174.262 166.334 174.229 166.365 174.194 166.393C174.167 166.426 174.141 166.458 174.117 166.491C174.084 166.539 174.062 166.591 174.055 166.647C174.042 166.682 174.04 166.715 174.048 166.749C174.046 166.784 174.055 166.815 174.073 166.845C174.081 166.878 174.101 166.904 174.13 166.925C174.163 166.965 174.205 166.991 174.258 167.002C174.293 167.017 174.328 167.032 174.361 167.047C174.445 167.069 174.529 167.071 174.613 167.051C174.71 167.03 174.798 166.993 174.88 166.936C174.961 166.88 175.027 166.812 175.08 166.73C175.118 166.676 175.142 166.617 175.149 166.554C175.166 166.497 175.166 166.441 175.151 166.384Z",
    fill: "url(#paint40_linear_6036_31799)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6036_31799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.772 149.104H141.734V152.976H290.772V149.104Z",
    fill: "#E9EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.434 254.732H159.861L151.322 145.344L154.407 145.119C157.771 175.773 165.789 248.85 166.434 254.732Z",
    fill: "#E9EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.181 145.344L272.641 254.732H266.068L278.096 145.119L281.181 145.344Z",
    fill: "#E9EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.705 162.127H169.798L165.378 139.953H267.125L262.705 162.127Z",
    fill: "#6774EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.076 162.514H169.426L164.852 139.566H267.651L263.076 162.514ZM170.169 161.739H262.333L266.599 140.34H165.904L170.169 161.739Z",
    fill: "#6774EC"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M188.54 144.92L186.255 158.455L180.708 158.572L179.517 151.56L178.325 158.064L172.778 158.26L170.474 144.92L175.318 144.49L176.294 152.595L177.603 144.49H181.411L182.935 152.693L183.716 144.49L188.54 144.92ZM199.237 144.392C199.198 145.004 199.163 145.61 199.13 146.209C199.097 146.808 199.055 147.413 199.003 148.025L194.862 148.24L194.765 149.47H197.675L197.46 152.498L194.53 152.595L194.433 154.021H196.855H198.573C198.534 154.737 198.492 155.45 198.446 156.16C198.407 156.863 198.372 157.569 198.339 158.279L189.921 158.474L190.234 144.392H199.237ZM209.163 152.908L208.753 157.244L200.53 157.888C200.569 155.616 200.612 153.357 200.657 151.111C200.709 148.865 200.771 146.606 200.843 144.334H205.921C205.771 145.76 205.628 147.185 205.491 148.611C205.355 150.03 205.257 151.463 205.198 152.908C205.504 152.921 205.807 152.928 206.107 152.928C206.406 152.928 206.709 152.928 207.015 152.928C207.379 152.928 207.737 152.924 208.089 152.918C208.441 152.911 208.799 152.908 209.163 152.908ZM220.3 144.744L219.753 148.865C219.564 148.813 219.375 148.777 219.187 148.758C218.998 148.738 218.809 148.728 218.62 148.728C218.138 148.728 217.679 148.793 217.243 148.924C216.807 149.047 216.42 149.239 216.081 149.5C215.749 149.76 215.482 150.086 215.28 150.476C215.085 150.867 214.987 151.326 214.987 151.853C214.987 152.192 215.04 152.485 215.144 152.732C215.254 152.98 215.407 153.185 215.603 153.347C215.798 153.51 216.029 153.631 216.296 153.709C216.563 153.787 216.856 153.826 217.175 153.826C217.416 153.826 217.666 153.8 217.927 153.748C218.187 153.696 218.444 153.627 218.698 153.543C218.952 153.458 219.2 153.36 219.441 153.25C219.681 153.139 219.903 153.025 220.105 152.908L219.714 157.498C219.46 157.628 219.183 157.745 218.884 157.849C218.591 157.947 218.288 158.035 217.976 158.113C217.663 158.185 217.351 158.24 217.038 158.279C216.726 158.318 216.426 158.338 216.14 158.338C215.313 158.338 214.541 158.185 213.825 157.879C213.109 157.573 212.487 157.153 211.96 156.619C211.433 156.085 211.016 155.457 210.71 154.734C210.411 154.005 210.261 153.22 210.261 152.381C210.261 151.267 210.42 150.219 210.739 149.236C211.058 148.247 211.527 147.381 212.146 146.638C212.764 145.896 213.529 145.31 214.441 144.881C215.359 144.451 216.413 144.236 217.605 144.236C218.054 144.236 218.513 144.272 218.982 144.344C219.457 144.415 219.896 144.549 220.3 144.744ZM233.868 151.58C233.868 152.172 233.8 152.745 233.663 153.299C233.526 153.845 233.328 154.36 233.068 154.842C232.814 155.323 232.501 155.766 232.13 156.17C231.765 156.567 231.352 156.909 230.89 157.195C230.434 157.482 229.936 157.706 229.396 157.869C228.855 158.025 228.282 158.103 227.677 158.103C227.091 158.103 226.531 158.028 225.997 157.879C225.47 157.729 224.975 157.521 224.513 157.254C224.051 156.98 223.631 156.655 223.253 156.277C222.882 155.893 222.563 155.47 222.296 155.008C222.036 154.539 221.831 154.038 221.681 153.504C221.538 152.97 221.466 152.413 221.466 151.834C221.466 151.267 221.534 150.714 221.671 150.174C221.808 149.627 222.003 149.112 222.257 148.631C222.517 148.149 222.83 147.706 223.194 147.303C223.559 146.899 223.966 146.551 224.415 146.258C224.871 145.965 225.362 145.737 225.89 145.574C226.417 145.411 226.974 145.33 227.56 145.33C228.504 145.33 229.363 145.476 230.138 145.769C230.919 146.062 231.583 146.482 232.13 147.029C232.683 147.569 233.11 148.227 233.409 149.002C233.715 149.77 233.868 150.629 233.868 151.58ZM229.532 151.834C229.532 151.554 229.49 151.284 229.405 151.023C229.327 150.756 229.21 150.522 229.054 150.32C228.898 150.112 228.702 149.946 228.468 149.822C228.24 149.692 227.976 149.627 227.677 149.627C227.371 149.627 227.097 149.682 226.857 149.793C226.616 149.903 226.407 150.056 226.232 150.252C226.062 150.441 225.932 150.665 225.841 150.926C225.75 151.179 225.704 151.45 225.704 151.736C225.704 152.01 225.743 152.283 225.821 152.556C225.9 152.83 226.017 153.077 226.173 153.299C226.329 153.52 226.521 153.699 226.749 153.836C226.984 153.972 227.254 154.041 227.56 154.041C227.866 154.041 228.139 153.982 228.38 153.865C228.627 153.741 228.836 153.579 229.005 153.377C229.174 153.168 229.304 152.931 229.396 152.664C229.487 152.397 229.532 152.12 229.532 151.834ZM250.65 144.236L249.751 158.572L245.298 158.767L245.337 151.209L243.325 157.303H241.607L240.064 151.853L240.044 158.181L235.532 158.318L235.728 144.822L240.747 144.627L242.739 151.092L245.396 144.236H250.65ZM261.62 144.392C261.581 145.004 261.545 145.61 261.513 146.209C261.48 146.808 261.438 147.413 261.386 148.025L257.245 148.24L257.148 149.47H260.058L259.843 152.498L256.913 152.595L256.816 154.021H259.237H260.956C260.917 154.737 260.875 155.45 260.829 156.16C260.79 156.863 260.754 157.569 260.722 158.279L252.304 158.474L252.616 144.392H261.62Z",
    fill: "url(#paint41_linear_6036_31799)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M121.082 30.3856C120.603 29.173 119.878 28.0017 118.723 27.3171C117.655 26.6847 116.266 26.5109 115.109 26.9998C114.264 27.3584 113.654 28.0321 113.301 28.8383C113.572 28.6123 113.898 28.4602 114.225 28.3276C114.562 28.1907 114.913 28.0755 115.27 27.9951C116.185 27.7865 117.155 28.169 117.768 28.8557C117.845 28.9426 117.794 29.0817 117.671 29.0861C116.873 29.1143 115.997 29.1491 115.371 29.7054C115.043 29.9966 114.816 30.3791 114.626 30.7681C114.419 31.1962 114.273 31.6569 114.205 32.1284C114.086 32.9477 114.211 33.7974 114.56 34.5493C114.862 35.1991 115.318 35.8162 115.94 36.2009C116.579 36.5964 117.325 36.6485 118.013 36.3378C118.101 36.2987 118.222 36.3443 118.218 36.453C118.207 36.8028 118.028 37.1006 117.867 37.4026C118.522 37.1027 119.133 36.7116 119.624 36.1857C120.189 35.5815 120.559 34.8362 120.828 34.0647C120.872 33.9387 121.049 33.9365 121.091 34.0647C121.395 34.9644 121.763 35.8488 122.257 36.6638C122.632 37.2809 123.095 37.8829 123.688 38.3088C122.89 37.1679 122.446 35.8532 122.136 34.4928C121.823 33.115 121.598 31.709 121.077 30.3856H121.082Z",
    fill: "url(#paint42_linear_6036_31799)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6036_31799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.127 32.7985C118 33.7292 117.236 34.4781 116.285 34.7069C116.285 34.7069 116.439 34.8313 117.019 34.8661C118.299 34.9443 119.464 34.0607 119.623 32.8905C119.782 31.7217 118.873 30.7097 117.591 30.6302C117.328 30.6142 117.071 30.6383 116.827 30.6976C117.702 31.0388 118.251 31.8679 118.125 32.7986L118.127 32.7985Z",
    fill: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.971 32.7932C114.969 32.8425 114.97 32.8931 114.971 32.9421C114.972 32.949 114.973 32.9574 114.974 32.9643C114.977 33.009 114.98 33.055 114.986 33.0993C114.987 33.1077 114.988 33.116 114.989 33.1229C114.994 33.1716 115.004 33.2197 115.014 33.2664C115.015 33.2762 115.017 33.2843 115.02 33.2925C115.032 33.3404 115.043 33.3884 115.058 33.4346C115.074 33.4822 115.09 33.5296 115.111 33.5753C115.113 33.582 115.117 33.59 115.12 33.5968C115.14 33.6425 115.16 33.6882 115.183 33.7321L115.183 33.7363C115.208 33.7814 115.233 33.8238 115.26 33.8674C115.262 33.8714 115.264 33.874 115.266 33.878C115.294 33.9214 115.322 33.9634 115.354 34.005L115.36 34.0129C115.423 34.0976 115.494 34.1759 115.571 34.2507L115.577 34.2557C115.775 34.4444 116.016 34.5975 116.288 34.7039C117.239 34.4751 118.003 33.7263 118.13 32.7955C118.251 31.8681 117.702 31.039 116.827 30.6978C116.531 30.7695 116.253 30.8899 116.008 31.0519L116.001 31.0568C115.906 31.1201 115.815 31.1901 115.73 31.2637L115.722 31.2701C115.68 31.3068 115.64 31.3447 115.602 31.3839C115.599 31.387 115.595 31.3901 115.592 31.3933C115.554 31.4324 115.518 31.4714 115.483 31.5129L115.48 31.5161C115.445 31.5562 115.412 31.599 115.381 31.6416C115.377 31.6477 115.371 31.6554 115.366 31.6614C115.335 31.704 115.306 31.7493 115.278 31.7943C115.251 31.8379 115.227 31.884 115.203 31.9301C115.199 31.9389 115.194 31.9464 115.19 31.9553C115.168 32.0012 115.145 32.0471 115.127 32.094C115.124 32.1013 115.12 32.1102 115.117 32.1175C115.1 32.1601 115.084 32.2039 115.07 32.2489C115.067 32.2562 115.065 32.2635 115.062 32.2708C115.047 32.3187 115.033 32.3679 115.023 32.4168C115.021 32.4282 115.019 32.4383 115.016 32.4498C115.005 32.5002 114.997 32.5516 114.988 32.6031C114.982 32.6543 114.977 32.7068 114.974 32.7577C114.974 32.769 114.973 32.7803 114.972 32.7902L114.971 32.7932Z",
    fill: "#69628C"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M139.236 111C136.201 111 133.736 108.535 133.736 105.5C133.736 102.465 136.201 100 139.236 100C142.271 100 144.736 102.465 144.736 105.5C144.736 108.535 142.271 111 139.236 111ZM139.236 101.092C136.806 101.092 134.828 103.07 134.828 105.5C134.828 107.93 136.806 109.908 139.236 109.908C141.666 109.908 143.645 107.93 143.645 105.5C143.645 103.07 141.666 101.092 139.236 101.092Z",
    fill: "url(#paint43_radial_6036_31799)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M160.236 53C158.305 53 156.736 51.2074 156.736 49C156.736 46.7926 158.305 45 160.236 45C162.168 45 163.736 46.7926 163.736 49C163.736 51.2074 162.168 53 160.236 53ZM160.236 45.7939C158.69 45.7939 157.431 47.233 157.431 49C157.431 50.767 158.69 52.2061 160.236 52.2061C161.782 52.2061 163.041 50.767 163.041 49C163.041 47.233 161.782 45.7939 160.236 45.7939Z",
    fill: "url(#paint44_radial_6036_31799)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M259.236 79C257.305 79 255.736 77.4315 255.736 75.5C255.736 73.5685 257.305 72 259.236 72C261.168 72 262.736 73.5685 262.736 75.5C262.736 77.4315 261.168 79 259.236 79ZM259.236 72.6946C257.69 72.6946 256.431 73.9539 256.431 75.5C256.431 77.0461 257.69 78.3054 259.236 78.3054C260.782 78.3054 262.041 77.0461 262.041 75.5C262.041 73.9539 260.782 72.6946 259.236 72.6946Z",
    fill: "url(#paint45_radial_6036_31799)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M187.736 73C184.425 73 181.736 70.5352 181.736 67.5C181.736 64.4648 184.425 62 187.736 62C191.047 62 193.736 64.4648 193.736 67.5C193.736 70.5352 191.047 73 187.736 73ZM187.736 63.0915C185.086 63.0915 182.927 65.0704 182.927 67.5C182.927 69.9296 185.086 71.9085 187.736 71.9085C190.387 71.9085 192.545 69.9296 192.545 67.5C192.545 65.0704 190.387 63.0915 187.736 63.0915Z",
    fill: "url(#paint46_radial_6036_31799)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M225.111 102.503L225.741 104.777C226.566 107.758 230.316 108.715 232.469 106.494L234.055 104.857C236.156 102.689 235.189 99.0638 232.288 98.2292L230.072 97.5918C227.068 96.7273 224.278 99.4894 225.111 102.503Z",
    fill: "#9C9CFF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M218.429 48.3287C219.68 47.0374 219.105 44.8785 217.377 44.3813C215.587 43.8665 213.926 45.5116 214.422 47.3062C214.914 49.0815 217.147 49.6515 218.429 48.3287Z",
    fill: "#9C9CFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.4774 107.514C65.4815 105.446 64.5597 101.988 61.792 101.192C58.9256 100.367 56.2638 103.002 57.0593 105.877C57.8462 108.72 61.4243 109.633 63.4774 107.514Z",
    fill: "#9C9CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(530.178 85.0753) rotate(90) scale(606.876 1112.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B88F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8A96FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#5C6BF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#3C4CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C4CAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(401.295 206.011) rotate(67.4693) scale(188.363 423.651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7488F2"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199158,
    stopColor: "#8796EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460674,
    stopColor: "#7C8DF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776031,
    stopColor: "#92A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8093FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7313 119.651) scale(116.801 116.336)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C5CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ACB7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.9521 200.849) scale(24.5248 24.4272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.89 216.058) scale(19.2437 19.1672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.845 215.021) scale(15.1845 15.1242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.938 68.2114) rotate(22.2137) scale(59.3412 64.8361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C5CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ACB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.82 165.091) rotate(22.2137) scale(46.2706 50.5553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.964 16.6811) rotate(-180) scale(100.061 203.974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C5CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ACB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.585 156.933) rotate(180) scale(21.0657 42.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.33 184.743) rotate(180) scale(16.3787 33.0119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(269.305 180.083) rotate(180) scale(13.1694 27.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFECFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387.251 301.973) rotate(-180) scale(171.048 172.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185075,
    stopColor: "#B9C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#BEC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762337,
    stopColor: "#D2DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6036_31799",
    x1: 108.247,
    y1: 32.5044,
    x2: 108.247,
    y2: 166.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6036_31799",
    x1: 120.273,
    y1: 21.7972,
    x2: 120.273,
    y2: 48.2428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6036_31799",
    x1: 206.951,
    y1: 162.194,
    x2: 206.951,
    y2: 254.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6036_31799",
    x1: 200.027,
    y1: 168.623,
    x2: 200.027,
    y2: 234.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6036_31799",
    x1: 151.218,
    y1: 137.186,
    x2: 151.218,
    y2: 205.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6036_31799",
    x1: 132.255,
    y1: 157.411,
    x2: 132.255,
    y2: 232.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6036_31799",
    x1: 141.682,
    y1: 162.303,
    x2: 141.682,
    y2: 231.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6036_31799",
    x1: 178.555,
    y1: 168.242,
    x2: 178.555,
    y2: 232.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6036_31799",
    x1: 128.929,
    y1: 148.053,
    x2: 128.929,
    y2: 150.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6036_31799",
    x1: 131.826,
    y1: 150.701,
    x2: 131.826,
    y2: 151.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6036_31799",
    x1: 135.485,
    y1: 152.835,
    x2: 135.485,
    y2: 154.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6036_31799",
    x1: 152.544,
    y1: 148.398,
    x2: 152.544,
    y2: 152.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6036_31799",
    x1: 158.647,
    y1: 163.946,
    x2: 158.647,
    y2: 164.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6036_31799",
    x1: 154.711,
    y1: 162.084,
    x2: 154.711,
    y2: 165.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6036_31799",
    x1: 162.768,
    y1: 169.578,
    x2: 162.768,
    y2: 170.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6036_31799",
    x1: 168.917,
    y1: 166.978,
    x2: 168.917,
    y2: 167.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6036_31799",
    x1: 147.976,
    y1: 167.807,
    x2: 147.976,
    y2: 169.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6036_31799",
    x1: 114.403,
    y1: 162.652,
    x2: 114.403,
    y2: 162.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6036_31799",
    x1: 115.044,
    y1: 162.027,
    x2: 115.044,
    y2: 163.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6036_31799",
    x1: 116.998,
    y1: 158.633,
    x2: 116.998,
    y2: 160.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6036_31799",
    x1: 116.113,
    y1: 159.063,
    x2: 116.113,
    y2: 159.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6036_31799",
    x1: 120.84,
    y1: 158.374,
    x2: 120.84,
    y2: 159.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6036_31799",
    x1: 115.718,
    y1: 150.047,
    x2: 115.718,
    y2: 151.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6036_31799",
    x1: 147.305,
    y1: 174.577,
    x2: 147.305,
    y2: 175.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6036_31799",
    x1: 147.984,
    y1: 182.331,
    x2: 147.984,
    y2: 183.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6036_31799",
    x1: 163.35,
    y1: 176.822,
    x2: 163.35,
    y2: 178.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6036_31799",
    x1: 162.428,
    y1: 178.061,
    x2: 162.428,
    y2: 178.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6036_31799",
    x1: 174.603,
    y1: 166.143,
    x2: 174.603,
    y2: 167.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6036_31799",
    x1: 278.553,
    y1: 146.429,
    x2: 265.887,
    y2: 146.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6036_31799",
    x1: 118.494,
    y1: 26.7181,
    x2: 118.494,
    y2: 38.3088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA843"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.236 105.5) scale(5.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C5D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ACBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.236 49) scale(3.5 4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C5D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ACBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.236 75.5) scale(3.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C5D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ACBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_6036_31799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.68 19.6127) scale(109.206 100.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C5D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ACBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6036_31799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 275,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6036_31799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.038,
    height: 115.166,
    fill: "white",
    transform: "translate(141.734 139.566)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6036_31799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.22316,
    height: 4.6924,
    fill: "white",
    transform: "translate(119.419 30.404) rotate(84.0233)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoparksHomeMobile);
export default __webpack_public_path__ + "static/media/dinoparks-home-mobile.1f60a2d4efe9b075f26099b154d081be.svg";
export { ForwardRef as ReactComponent };